export default "__VITE_ASSET__D0AZ7RBz__"